import React, { Suspense } from 'react'
import { Outlet } from 'react-router'

import AuthGuard from '@/components/guards/AuthGuard'
import CompanyDashboardLayout from '@/components/layouts/DashboardLayout/CompanyDashboardLayout'
import ProfessionalNetworkPageHeader from '@/components/layouts/DashboardLayout/CompanyDashboardProfessionalNetworkLayout/ProfessionalNetworkPageHeader'
import { USER_TYPE } from '@/types/misc'

const CompanyDashboardProfessionalNetworkLayout: React.FC = () => (
  <AuthGuard requiredUserType={USER_TYPE.company}>
    <CompanyDashboardLayout padded>
      <ProfessionalNetworkPageHeader />

      {/*
      The `null` fallback is intentional as we don't want to show anything
      whilst the route code is being imported. The route code import happens
      very quickly so showing a fallback doesn't make a sense and only adds
      a flicker.
      */}
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </CompanyDashboardLayout>
  </AuthGuard>
)

export default CompanyDashboardProfessionalNetworkLayout
